export default (val, func) => (val ? func(val) : null);
